export default __webpack_public_path__ + "static/media/bootsplash_logo_original.16dbe240.png";